///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.duplicate_vendor = abcsetup.duplicate_vendor || {};
abcsetup.duplicate_vendor.sign = abcsetup.duplicate_vendor.sign || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.duplicate_vendor.sign = {
    /**
     *
     */
    init: function () {
        setTimeout(function () {
            $('#messages-container .alert').fadeOut('slow');
        }, 5000);

        // Reject button clicked
        $('#reject-btn, .reject-btn.required').on('click', function () {
            return abcsetup.duplicate_vendor.sign._rejectItem($(this));
        });
    },

    /**
     * Reject the item
     */
    _rejectItem: function (btn) {
        //const rejectReasonField = $('textarea[name="reject_reason"].required') || $('textarea[name="reject_reason_text[other]"].required');
        const rejectReasonField = $('textarea[name="signature_rejection_reason"].required');

        if (!rejectReasonField.val()) {
            rejectReasonField.addClass('error');
            return false;
        }

        btn.unbind('click').attr('type', 'submit').trigger('click');
        abcsetup.blockUI(true);
    },
}
